import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Collapse, Button, ButtonGroup } from 'reactstrap';
import { BarChart, Bar, Brush, ReferenceLine, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

import api from "../../../api/api.js";
import apifunctions from "../../../api/functions";

import FiltrosResumen from "./FiltrosResumen";
import TablaMovimientos from "./TablaMovimientos";
import TablaDeudas from './TablaDeudas.js';
import SelectTable from './SelectTable.js';
import { format, formatCurrency } from '../../../functions/functions';

import "./styles.css";
import { LotesDisponibles } from './LotesDisponibles.js';

const SimpleBarChart = (props) => (
  <BarChart width={1600} height={300} data={props.data}
    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="mes" />
    <YAxis />
    <Tooltip formatter={value => format(value)} />
    <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} />
    <ReferenceLine y={0} stroke='#000' />
    {/* <Brush name="Mes" dataKey='mes' height={30} stroke="#8884d8"/> */}
    <Bar name="Movimientos ($)" dataKey="monto_movimientos" fill="#63c2de" />
    <Bar name="Deudas ($)" dataKey="monto_deudas" fill="#f86c6b" />
  </BarChart>
)

const initialForm = {
  loteoId: 0,
  desde: moment().startOf('month').subtract(11, 'month'),
  hasta: moment().endOf('month')
}

const getParametersFilter = (filter) => {
  let toReturn = []
  if (filter.loteoId)
    toReturn.push("loteo__id[exact]=" + filter.loteoId + "");

  if (filter.desde && filter.hasta)
    toReturn.push(
      `fecha[range]=${moment(filter.desde).format('YYYY-MM-DD')},${moment(filter.hasta).format('YYYY-MM-DD')}`
    )
  return toReturn;
}

const Resumen = (props) => {

  const [filter, setFilter] = useState(initialForm);
  const [dataGrafico, setDataGrafico] = useState([]);
  const [showTable, setShowTable] = useState(1);

  const setInput = (k, v) => {
    let errors = filter.errors;
    if (errors) delete errors[k];
    setFilter({
      ...filter,
      [k]: v,
      errors: errors
    })
  }

  useEffect(() => updateGrafico(filter), [filter]);

  const updateGrafico = (filter) => {

    let parameters = {
      filters: getParametersFilter(filter)
    }

    apifunctions.get(
      api.inversionista.grafico, null, 1, parameters,
      (data) => setDataGrafico(data.data.grafico),
      (e) => setDataGrafico([]),
      (e) => setDataGrafico([]),
    )
  }

  return (
    <div className="ingresos-container p-3 col-12">
      <Row>
        <FiltrosResumen {...filter} onChange={setInput} />
      </Row>
      <Row>
        <LotesDisponibles filter={filter} />
      </Row>
      <Row>
        {dataGrafico.length > 0 && <SimpleBarChart data={dataGrafico} />}
      </Row>
      <Row className="justify-content-center my-3">
        <SelectTable showTable={showTable} setShowTable={setShowTable} />
      </Row>
      <Collapse isOpen={showTable == 1}>
        {showTable == 1 && <TablaMovimientos filter={filter} />}
      </Collapse>
      <Collapse isOpen={showTable == 2}>
        {showTable == 2 && <TablaDeudas filter={filter} />}
      </Collapse>
    </div>
  );

}

export default Resumen;



// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/Resumen.js